import { Component } from "@angular/core";

@Component({
    selector: "app-payment",
    templateUrl: "./payment.component.html",
    styleUrls: ["./payment.component.scss"],
    standalone: false,
})
export class PaymentComponent {}
